import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import SectionTitle from '../shared/sectionTitle.vue';
import SuggestionsListsGrid from './suggestionsListsGrid.vue';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import LibrariesList from './librariesList.vue';
import SuggestionsListCreateDialog from './suggestionsListCreateDialog.vue';
import Projects from './projects.vue';
import suggestionsListsQuery from '../../queries/suggestionsLists';
import { ViewerContext } from '../../types/viewer_context';

@Component({
  components: {
    Projects,
    SingleMainContainer,
    SectionTitle,
    LibrariesList,
    SuggestionsListsGrid,
    SuggestionsListCreateDialog,
  },
})
export default class Dashboard extends Vue {
  @Getter public viewerContext!: ViewerContext;

  // the query we want to refetch then a new project is created.
  public readonly refetchQueryForGrid = suggestionsListsQuery;

  public openCreateDialog() {
    const editor = this.getCreateDialog();
    editor.show();
  }

  private getCreateDialog(): any {
    return this.$refs.createDialog;
  }
}
